<!-- Container-fluid starts-->
<div class="container-fluid">
  <div class="row">
      <div class="col-lg-12 col-md-12 col-12">
        <div class="card">
              <div class="card-header">
                  <h5>System Log events</h5>
              </div>
              <!-- widgets starts-->
              <div class="card-body custom-datatable">
              <div class="row">
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="card o-hidden">
                    <div class="card-body bg-info b-r-4">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center">
                          <app-feather-icons [icon]="'alert-circle'"></app-feather-icons>
                        </div>
                        <div class="media-body"><span class="m-0">Informations</span>
                          <h4 class="mb-0 counter">{{es1}}</h4><i class="icon-bg"
                            data-feather="alert-circle"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="card o-hidden">
                    <div class="bg-warning b-r-4 card-body">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center">
                          <app-feather-icons [icon]="'alert-triangle'"></app-feather-icons>
                        </div>
                        <div class="media-body"><span class="m-0">Warrnings</span>
                          <h4 class="mb-0 counter">{{es2}}</h4><i class="icon-bg"
                            data-feather="alert-triangle"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="card o-hidden">
                    <div class="bg-danger b-r-4 card-body">
                      <div class="media static-top-widget">
                        <div class="align-self-center text-center">
                          <app-feather-icons [icon]="'alert-octagon'"></app-feather-icons>
                        </div>
                        <div class="media-body"><span class="m-0">Errors</span>
                          <h4 class="mb-0 counter">{{es3}}</h4><i class="icon-bg"
                            data-feather="alert-octagon"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- widgets ends-->

                  <!-- <input type='text' class="filter-ngx form-control" placeholder='Type to filter the username column...'
                      (keyup)='updateFilter($event)' /> -->
                  <ngx-datatable
                    class='bootstrap'
                    [columnMode]="ColumnMode.flex"
                    [externalPaging]="true"
                    [count]="page.totalElements"
                    [offset]="page.pageNumber"
                    [limit]="page.size"
                    (page)="setPage($event)"
                    [headerHeight]="50"
                    [footerHeight]="50"
                    rowHeight="auto"
                    [rows]="eventsData"
                    [selected]="selected"
                    [selectionType]="SelectionType.single"
                    (select)='onSelect($event)'>
                    <ngx-datatable-column
                      [width]="30"
                      [sortable]="false"
                      [canAutoResize]="false"
                      [draggable]="false"
                      [resizeable]="false"
                      >
                    </ngx-datatable-column>

                    <ngx-datatable-column name="timeStampUtc" [flexGrow]="1">
                      <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                       <span class="myHeader txt-primary" (click)="sort()">Time</span>
                      </ng-template>
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        {{row.timeStampUtc | date : 'd/MM/yyyy HH:mm:ss'}}
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="username" [flexGrow]="1">
                      <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                        <span class="myHeader txt-primary" (click)="sort()">User name</span>
                      </ng-template>
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        {{row.username}}
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="source" [flexGrow]="1">
                      <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                        <span class="myHeader txt-primary" (click)="sort()">Source</span>
                      </ng-template>
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        {{row.source}}
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="logLevel" [flexGrow]="1">
                      <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                       <span class="myHeader txt-primary"  (click)="sort()">Level</span>
                      </ng-template>
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <div *ngIf="row.logLevel=='Warning'">
                          <span class="badge badge-warning">{{row.logLevel}}</span>
                        </div>
                        <div *ngIf="row.logLevel=='Error'">
                          <span class="badge badge-danger">{{row.logLevel}}</span>
                        </div>
                        <div *ngIf="row.logLevel=='Information'">
                          {{row.logLevel}}
                        </div>
                      </ng-template>
                    </ngx-datatable-column>

                    <ngx-datatable-column name="info" [flexGrow]="3" [sortable]="false">
                      <ng-template let-column="column" let-sort="sortFn"  ngx-datatable-header-template>
                       <span class="myHeader txt-primary" (click)="sort()">Info</span>
                      </ng-template>
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        {{row.info}}
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
              </div>
              <div class="card-footer btn-showcase">
                <button class="btn btn-pill btn-sm btn-info" type="button" placement="top" ngbTooltip="remove selected events" (click)="onDelete()">
                  Delete</button>
                <button class="btn btn-pill btn-sm btn-info" type="button" placement="top"
                ngbTooltip="clear entire log" (click)="onDeleteAll()">Delete All</button>
              </div>
        </div>
      </div>
  </div>
</div>
<!-- Container-fluid Ends-->
